import {apiClient} from "@/state/modules/apiClient";

const controller = "Export";
const jobController = "ExportJob";

export const actions = {
    async dsUser({commit}) {
        return apiClient.get(controller + "/excel-dsuser");
    },
    async create({commit}, payload) {
        return apiClient.post(jobController + "/create", payload);
    },
    async getPaging({commit}, params) {
        return apiClient.post(jobController + "/get-paging", params);
    },
    async getById({commit}, id) {
        return apiClient.get(jobController + "/get-by-id/" + id);
    },
    async delete({commit}, id) {
        return apiClient.delete(jobController + "/delete/" + id);
    },
};
